import React from 'react';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from './screenFrame.module.css';

import { ReactComponent as BackArrow } from 'asset/IconsPack/at_arrow-left-thin.svg';
import MedallionLogo from 'asset/img/Medallion_Logo.svg';

const ScreenFrame = ({
    logo,
    title,
    subTitle,
    showBack,
    header,
    stepper,
    footer,
    cardClassName,
    bodyClassName,
    footerClassName,
    children,
}) => (
    <Box className={styles.screen}>
        <Box component="header" className={styles.navbar}>
            <img src={logo || MedallionLogo} alt="" className={styles.logo} />
        </Box>
        {stepper}
        <Box className={styles.content}>
            <Box className={clsx(styles.card, cardClassName)}>
                {header && <Box className={styles.header}>{header}</Box>}
                {title && (
                    <Box className={clsx(styles.header, showBack && styles.headerWithBack)}>
                        {showBack && <BackArrow className={styles.backArrow} />}
                        <Box>
                            <Typography className={styles.title}>{title}</Typography>
                            {subTitle && (
                                <Typography className={styles.subTitle}>{subTitle}</Typography>
                            )}
                        </Box>
                    </Box>
                )}
                <Box className={clsx(styles.body, bodyClassName)}>{children}</Box>
                {footer && <Box className={clsx(styles.cardFooter, footerClassName)}>{footer}</Box>}
            </Box>
        </Box>
    </Box>
);

ScreenFrame.propTypes = {
    logo: PropTypes.string,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    showBack: PropTypes.bool,
    header: PropTypes.node,
    stepper: PropTypes.node,
    footer: PropTypes.node,
    cardClassName: PropTypes.string,
    bodyClassName: PropTypes.string,
    footerClassName: PropTypes.string,
    children: PropTypes.node,
};

export default ScreenFrame;
